module.exports = __webpack_public_path__ + "static/img/u15.e64a5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u15.png
// module id = pvij
// module chunks = 19